import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "file-preview-dialog"
};
import { ref, watch } from 'vue';
import { CloseIcon } from 'tdesign-icons-vue-next';
import Preview from './Preview.vue';
import { useModel } from '@/hooks/useModel';
export default {
  __name: 'FilePreviewDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: ''
    }
  },
  emits: ['update:visible'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var visible = useModel({
      props: props,
      emit: emit,
      key: 'visible'
    });
    var localVisible = ref(props.visible);
    watch(function () {
      return props.visible;
    }, function (value) {
      localVisible.value = value;
    });
    watch(function () {
      return localVisible.value;
    }, function (value) {
      emit('update:visible', value);
    });
    var handleClose = function handleClose() {
      visible.value = false;
    };
    return function (_ctx, _cache) {
      var _component_t_popup = _resolveComponent("t-popup");
      return _openBlock(), _createBlock(_component_t_popup, {
        visible: localVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return localVisible.value = $event;
        }),
        placement: "center"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(CloseIcon), {
            class: "close-icon",
            onClick: handleClose
          }), _createVNode(Preview, {
            class: "preview-box",
            path: props.path
          }, null, 8, ["path"])])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};